import React from 'react';
import manufacturer from '../assets/manufacturer.png';
import warehouse from '../assets/warehouse.png';
import lawService from '../assets/law-service.png';

const Projects = () => {
  const projects = [
    { name: "Venom Computer World", img: manufacturer, link: "https://venom-computer-world.web.app/" },
    { name: "Bookathon Warehouse", img: warehouse, link: "https://bookathon-warehouse-client.web.app/" },
    { name: "Tanbir's Legal Solution", img: lawService, link: "https://tanbirs-legal-solution.web.app/" },
  ];
  return (
    <div name='work' className='w-full md:h-screen text-gray-300 bg-[#0a192f]'>
      <div className='max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full'>
        <div className='pb-8'>
          <p className='text-4xl font-bold inline border-b-4 text-gray-300 border-pink-600'>
            Projects
          </p>
          <p className='py-6'>Check out my Projects which I have done recently.</p>
        </div>

        {/* Container */}
        <div className='grid sm:grid-cols-2 md:grid-cols-3 gap-4'>
          {
            projects.map((p, i) =>
              <div
                style={{ backgroundImage: `url(${p.img})` }}
                className='shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div'
              >
                {/* Hover Effects */}
                <div className='opacity-0 group-hover:opacity-100'>
                  <span className='text-2xl font-bold text-white tracking-wider'>
                    {p.name}
                  </span>
                  <div className='pt-8 text-center'>
                    <a href={p.link} target='_blank'>
                      <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>
                        Live Site
                      </button>
                    </a>
                    <a href='/'>
                      <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>
                        Details
                      </button>
                    </a>
                  </div>
                </div>
              </div>
            )
          }

        </div>
      </div>
    </div>
  );
};

export default Projects;
